<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
    <button type="button" class="close" style="margin-left: 0;" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
        <label>{{message}}</label>
        <input type="text" class="form-control"  >
    </div>
    
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger m-1" (click)="decline()">{{ btnCancelText }}</button>
    <button type="button" class="btn btn-primary m-1" (click)="accept()">{{ btnOkText }}</button>
  </div>